
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* KEYWORDS: contact email feedback questions support help */
    }
    <h1>{`Contact the Brightlayer UI Team`}</h1>
    <p>{`Brightlayer UI is constantly evolving and adding new technical documentation, live code examples, components, and more. As the system grows, we welcome your feedback and suggestions on how we can make the system more useful for you and your team. Please do not hesitate to contact us regarding any issues you experience or potential opportunities for improvement.`}</p>
    <h2>{`How to Contact Us`}</h2>
    <p>{`If you have any questions or feedback about Brightlayer UI or how to use it, you can email the team directly at `}<a href="mailto:brightlayer-ui@eaton.com"><a parentName="p" {...{
          "href": "mailto:brightlayer-ui@eaton.com"
        }}>{`brightlayer-ui@eaton.com`}</a></a>{`. We typically respond to all inquiries within one business day.`}</p>
    <p>{`We look forward to hearing from you!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;